import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import PropTypes from 'prop-types';
import ImageView from '../../Images/ImageView';

FileUploadView.propTypes = {
  pathList: PropTypes.array,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

function FileUploadView(props) {
  // MARK: ---- PROPERTIES ----
  const { pathList, onCancel, onConfirm } = props;

  return (
    <div>
      {/* body */}
      <div className="row m-0 p-0 mt-2 px-3">
        {pathList.map((path, index) => (
          <div key={index} className="p-0 col-6 mb-2 p-2">
            <ImageView name={`IMAGE_${index}`} path={path} />
          </div>
        ))}
      </div>

      {/* footer */}
      <div
        className="d-flex align-items-center gap-3 px-4 py-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null, true)}
        {onConfirm && UIHelper.buildGreenButton('Xác nhận', onConfirm, null, true)}
      </div>
    </div>
  );
}

export default FileUploadView;
